import moved from './moved'
import edited from './edited'
import created from './created'
import trashed from './trashed'
import restored from './restored'
import shared from './shared'
import unshared from './unshared'
import starred from './starred'
import transferred from './transferred'
import deleted from './deleted'
import completed from './completed'
import copied from './copied'
// import app from '~/main'

const mappedEvents = {}

;([
  moved,
  edited,
  created,
  trashed,
  restored,
  shared,
  unshared,
  starred,
  transferred,
  deleted,
  completed,
  copied
]).forEach(e => {
  if (!e.name) {
    console.error(e)
    throw new Error('You must define a name attribute for the event')
  }
 // e.defaultHandler = (payload) => { e.defaultHandler.call(app, payload) }

  mappedEvents[e.name] = e
})

export default mappedEvents



// WEBPACK FOOTER //
// ./src/events/all.js